export const enquiryOptions = [
  {
    label: "ATO & ACP applications",
    value: "ATO and ACP applications",
  },
  {
    label: "Certificates, candidate verification",
    value: "Certificates, candidate verification",
  },
  {
    label: "Complaints",
    value: "Complaints",
  },
  {
    label: "Exams, training and self-study",
    value: "Exams, training and self-study",
  },
  {
    label: "GDPR",
    value: "GDPR",
  },
  {
    label: "Global Partner Portal (GPP)",
    value: "Global Partner Portal (GPP)",
  },
  {
    label: "Infringements",
    value: "Infringements",
  },
  {
    label: "Licensing",
    value: "Licensing",
  },
  {
    label: "My Axelos account and subscription",
    value: "My Axelos account and subscription",
  },
  {
    label: "Publications, study material",
    value: "Publications, study material",
  },
  {
    label: "Successful Candidates Register",
    value: "Successful Candidates Register",
  },
  {
    label: "Website and technical feedback",
    value: "Website and technical feedback",
  },
];
